import {
  FETCH_WELD_PARAMETERS_REQUEST,
  FETCH_WELD_PARAMETERS_SUCCESS,
  FETCH_WELD_PARAMETERS_FAILURE,
  WELD_PARAMETERS_LOADER_START,
  WELD_PARAMETERS_LOADER_STOP,
  UPDATE_RENAME_PASSES,
  PUT_RENAME_LOADER_START,
  PUT_RENAME_LOADER_STOP,
} from "./types";

const initialState = {
  loading: false,
  data: null,
  error: null,
  weldParameterErrors: null,
};

const data360LiveWeldParameterReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_WELD_PARAMETERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_WELD_PARAMETERS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
        weldParameterErrors: action.payload.weldParameterErrors || null,
      };
    case FETCH_WELD_PARAMETERS_FAILURE:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
        weldParameterErrors: null,
      };
    case WELD_PARAMETERS_LOADER_START:
      return {
        ...state,
        loading: true,
      };
    case WELD_PARAMETERS_LOADER_STOP:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_RENAME_PASSES:
      return {
        ...state,
      };
    case PUT_RENAME_LOADER_START:
      return {
        ...state,
        loading: true,
      };
    case PUT_RENAME_LOADER_STOP:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};

export default data360LiveWeldParameterReducer;
